import apiService from "./apiService";

export const getWishlistService = (query) => {
  let queryParams = {
    page: query?.page ?? 1,
    item_per_page: 10,
    search_label: query?.item,
    count_sort_order: query?.sort
  }
  return apiService.get(URIS.wishlist, {params: queryParams})
}

const URIS = {
  wishlist: '/v1/pharmacy/wishlists',
}




